import React, { useState, useEffect } from "react";
import CustomLink from "@gc-npm/components.custom-link";
import { useSelector } from "react-redux";
import IconGlyph from "@gc-npm/components.icon-glyph";
import { ICON_ID } from "@gc-npm/utils.enums.icon-id";

import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import SubSection from "@/components/Section/SubSection";
import OneLineSection from "@/components/Section/OneLineSection";
import { API_STATUS, LAYOUT_TYPES } from "@/utils/constants";
import { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";
import { getCenteredActiveId } from "@/utils/index";

const COMPONENT_NAME = "section";

const Section = (props) => {
  const { blockName, title, cmsHandler, position } = props;

  const [activeSlideConectivityId, setActiveSlideConectivityId] =
    useState(false);
  const conectividades = useSelector(
    (state) => state.modulos?.conectividad?.conexion?.items || []
  );
  const status = useSelector((state) => state.modulos.statusModulos);
  const screenType = useSelector((state) => state.UI.screenType);
  const layout = useSelector((state) => state.UI.layout);
  const minorLMPrice = useSelector((state) => state.UI.minorLMPrice);
  const conectividadItemsSelected = useSelector(
    (state) => state.cart?.modulos?.conectividad?.items || []
  );

  let subSectionsKeys = Object.keys(props);
  const priority = ["conexion", "lme", "bono"];

  // Extrae los prioritarios en orden
  subSectionsKeys = [
    ...priority.filter((p) => subSectionsKeys.includes(p)),
    ...subSectionsKeys.filter((k) => !priority.includes(k)),
  ];
  const taggingInfo = {
    componentContent: COMPONENT_NAME,
    componentName: blockName,
    componentProduct: "",
    componentVariation: "All",
    eventType: "click",
  };

  useEffect(() => {
    const selectedId =
      conectividadItemsSelected
        .filter((item) => item.subcategory === "conexion" && !item?.unsubscribe)
        .map((item) => item.id)[0] || null;

    // Extraer IDs válidos de conectividades
    const sectionIds = conectividades
      .filter((item) => item?.id && !item?.logic?.hide)
      .map((item) => item.id);
    const centeredid = getCenteredActiveId(sectionIds, selectedId);
    if (centeredid !== activeSlideConectivityId) {
      setActiveSlideConectivityId(centeredid);
    }
  }, [conectividadItemsSelected]);

  const fake = status === API_STATUS.LOADING;
  if (!fake) {
  }
  if (
    !subSectionsKeys ||
    !Array.isArray(subSectionsKeys) ||
    !subSectionsKeys.length > 0
  ) {
    return null;
  }

  return (
    <section className={`section ${blockName}`}>
      <div className={`${fake ? "skeleton" : ""} caption`}>
        {position && layout === LAYOUT_TYPES.ALL && (
          <div className="position">
            <IconGlyph
              id={`circle-${position}-solid-m`}
              height={24}
              width={24}
              color={COLOR_DICTIONARY.MOVISTAR_BLUE}
            />
          </div>
        )}
        {title && (
          <TextInfo
            text={title}
            size={TEXT_SIZE.T6}
            color={TEXT_COLOR.BLACK}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            kind={TEXT_KIND.HEADING}
            level={TEXT_HEADING_LEVEL.H2}
          />
        )}
      </div>
      {subSectionsKeys.map((subSectionKey) => {
        if (props[subSectionKey] && props[subSectionKey].items) {
          const {
            title: subSectionTitle,
            items,
            foldedSection,
            checkBoxSection,
          } = props[subSectionKey];
          if (
            items &&
            Array.isArray(items) &&
            items.length > 0 &&
            !checkBoxSection
          ) {
            const itemsToRender = items.filter((item) => {
              if (item?.logic?.hide) return false;
              if (item.category === "conectividad") {
                return item.subcategory === "conexion";
              }
              return true;
            });
            return (
              <SubSection
                screenType={screenType}
                fake={fake}
                foldedSection={foldedSection}
                subSectionKey={subSectionKey}
                cmsHandler={cmsHandler}
                subSectionTitle={subSectionTitle}
                itemsTorender={itemsToRender}
                checkBoxSection={checkBoxSection}
                blockName={blockName}
                activeSlideConectivityId={activeSlideConectivityId}
              />
            );
          }
        }
      })}
      {blockName === "conectividad" && (
        <div className="extras-items">
          {subSectionsKeys.map((subSectionKey) => {
            const subSection = props[subSectionKey];
            if (subSection && subSection.items) {
              const {
                title: subSectionTitle,
                items,
                foldedSection,
                checkBoxSection,
              } = subSection;

              if (
                items &&
                Array.isArray(items) &&
                items.length > 0 &&
                checkBoxSection
              ) {
                const itemsTorender = items.filter(
                  (item) => !item?.logic?.hide
                );

                return (
                  <OneLineSection
                    key={subSectionKey}
                    screenType={screenType}
                    fake={fake}
                    foldedSection={foldedSection}
                    subSectionKey={subSectionKey}
                    subSectionTitle={subSectionTitle}
                    itemsTorender={itemsTorender}
                  />
                );
              }
            }
            return null;
          })}
        </div>
      )}

      <style jsx>
        {`
          .section {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            background-color: white;
            margin-right: 1rem;
            .caption {
              display: flex;
              align-items: center;
              gap: 0.5rem;
              width: fit-content;
              .position {
                display: flex;
                align-items: center;
                align-self: stretch;
              }
            }
            .extras {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              width: fit-content;
              .lm {
                display: flex;
                flex-direction: row;
                align-content: center;
                align-items: center;
                gap: 0.5rem;
              }
              &-items {
                display: flex;
                flex-direction: column;
                gap: 1rem;
              }
            }
          }
          @media screen and (max-width: 768px) {
            .section {
              margin-right: 0rem;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Section;
